import React, {useEffect, useState} from 'react';
import {isMinzdravUser, isRoivUser, SubUser} from "../../../services/models/sub_user";
import DatePicker from "react-datepicker";
import {datePickerConfig} from "../../Events/EventModal/datepickerStyles";
import styles from "./ReportHeader.module.css";
import {getISOYear, getLocalWeek} from "../../../Utils/translateDate";
import {ReportType} from "../../../services/models/report";
import {classNames} from "../../../Utils/classNames/classNames";
import {ExportToExcel} from "../ExportToExcel/ExportToExcel";
import stylesButtons from "../../../assets/styles/buttons.module.css";
import {FormActionButton} from "../../shared/buttons/FormActionButton";
import "react-datepicker/dist/react-datepicker.css";
import "./datepicker.css";
import {UserSelect} from "../UserSelect/UserSelect";
import {Administrator} from "../../../services/models/administrator";

const CustomDateInput = React.forwardRef<HTMLInputElement, any>(
    ({value, onClick, onChange}, ref) => (
        <input
            className={styles.datePickerInput}
            onClick={onClick}
            value={value}
            onChange={onChange}
            ref={ref}
            readOnly
        />
    )
);

interface ReportHeaderProps {
    isAdmin?: boolean;
    users?: SubUser[];
    selectedWeek: { year: number; week: number };
    setSelectedWeek: React.Dispatch<React.SetStateAction<{ year: number; week: number }>>;
    setReportType?: React.Dispatch<React.SetStateAction<ReportType>>;
    reportType?: string;
    onSave?: () => void;
    isSaving?: boolean;
    selectedUserId?: string | null;
    onUserChange?: (userId: string) => void;
    reportData?: any;
    userName?: string;
    user: Administrator | SubUser | null;
    isAllowedUser?: boolean | null;
}

export const ReportHeader: React.FC<ReportHeaderProps> = ({
                                                              isAdmin,
                                                              selectedWeek,
                                                              setSelectedWeek,
                                                              users = [],
                                                              onSave,
                                                              isSaving = false,
                                                              selectedUserId,
                                                              onUserChange,
                                                              setReportType,
                                                              reportType,
                                                              reportData,
                                                              userName,
    user,
    isAllowedUser
                                                          }) => {

    const getDateFromWeekYear = (year: number, week: number) => {
        const date = new Date(year, 0, 1); // Start with January 1st of the given year
        // Find the first Thursday of the year
        while (date.getDay() !== 4) {
            date.setDate(date.getDate() + 1);
        }
        // Move to the first week
        date.setDate(date.getDate() + 7 * (week - 1));
        // Go back to Monday
        date.setDate(date.getDate() - 3);
        return date;
    };
    const switchTypeHandler = (type: ReportType) => () => {
        if (setReportType) {
            setReportType(type);
        }
    };
    const [startDate, setStartDate] = useState(getDateFromWeekYear(selectedWeek.year, selectedWeek.week));

    // Функция для получения даты начала и окончания недели
    const getWeekRange = (date: Date) => {
        const start = new Date(date);
        const day = start.getDay();
        const diff = start.getDate() - day + (day === 0 ? -6 : 1);
        start.setDate(diff);

        const end = new Date(start);
        end.setDate(start.getDate() + 6);

        return {start, end};
    };

    // Форматирование даты в строку
    const formatDate = (date: Date) => {
        return date.toLocaleDateString('ru-RU', {
            day: '2-digit',
            month: '2-digit',
            year: 'numeric'
        });
    };

    // Получаем текущий диапазон недели
    const {start: weekStart, end: weekEnd} = getWeekRange(startDate);
    const weekRangeString = `${formatDate(weekStart)} - ${formatDate(weekEnd)}`;

    const isRoivOrMinzdrav = user && (isRoivUser(user as SubUser) || isMinzdravUser(user as SubUser));

    return (
        <div className={styles.headerWrapper}>
            <div className="d-flex w-100 mb-4">
                {(!isRoivOrMinzdrav || isAllowedUser) && (
                    <div
                        className={classNames(styles.reportType, {[styles.active]: reportType === "report"}, [])}
                        onClick={(isAdmin || isAllowedUser) ? switchTypeHandler("report") : () => {
                        }}
                    >
                        Проф.осмотры
                    </div>
                )}
                {(isAdmin || isRoivOrMinzdrav || isAllowedUser) && (
                    <div
                        className={classNames(styles.reportTypeDpo, {[styles.active]: reportType === "logsChart"}, [])}
                        onClick={(isAdmin || isAllowedUser) ? switchTypeHandler("logsChart") : () => {}}
                    >
                        Статистика
                    </div>
                )}
                {isAdmin && (
                    <div
                        className={classNames(styles.reportTypeDpo, {[styles.active]: reportType === "logs"}, [])}
                        onClick={switchTypeHandler("logs")}
                    >
                        Логи
                    </div>
                )}

            </div>
            {reportType === "report" && (
                <div className={styles.headerInner}>
                    <div className={styles.left}>
                        {isAdmin && (
                            <UserSelect
                                users={users}
                                selected={selectedUserId}
                                onUserChange={onUserChange}
                            />
                        )}
                        <div className={styles.datePickerWrapper}>
                            <button
                                type="button"
                                className={styles.arrowButton}
                                onClick={() => {
                                    const currentDate = getDateFromWeekYear(selectedWeek.year, selectedWeek.week);
                                    currentDate.setDate(currentDate.getDate() - 7);
                                    const newYear = getISOYear(currentDate);
                                    const newWeek = getLocalWeek(currentDate);
                                    setSelectedWeek({year: newYear, week: newWeek});
                                    setStartDate(currentDate);
                                }}
                            >
                                &#8249;
                            </button>
                            <DatePicker
                                selected={startDate}
                                onChange={(date: Date | null) => {
                                    if (date) {
                                        const year = getISOYear(date);
                                        const week = getLocalWeek(date);
                                        setStartDate(date);
                                        setSelectedWeek({year, week});
                                    } else {
                                        const today = new Date();
                                        const year = getISOYear(today);
                                        const week = getLocalWeek(today);
                                        setStartDate(today);
                                        setSelectedWeek({year, week});
                                    }
                                }}
                                dateFormat={`w нед., ${weekRangeString}`}
                                // @ts-ignore
                                locale={datePickerConfig.locale}
                                calendarStartDay={datePickerConfig.calendarStartDay}
                                showWeekNumbers
                                showWeekPicker
                                filterDate={(date: Date) => {
                                    const today = new Date();
                                    const currentYear = getISOYear(today);
                                    const currentWeek = getLocalWeek(today);
                                    const year = getISOYear(date);
                                    const week = getLocalWeek(date);
                                    return (year < currentYear) || (year === currentYear && week <= currentWeek);
                                }}
                                customInput={<CustomDateInput/>}
                            />
                            <button
                                type="button"
                                className={styles.arrowButton}
                                onClick={() => {
                                    const currentDate = getDateFromWeekYear(selectedWeek.year, selectedWeek.week);
                                    currentDate.setDate(currentDate.getDate() + 7);
                                    const newYear = getISOYear(currentDate);
                                    const newWeek = getLocalWeek(currentDate);

                                    const today = new Date();
                                    const currentYear = getISOYear(today);
                                    const currentWeek = getLocalWeek(today);

                                    if (newYear < currentYear || (newYear === currentYear && newWeek <= currentWeek)) {
                                        setSelectedWeek({year: newYear, week: newWeek});
                                        setStartDate(currentDate);
                                    }
                                }}
                                disabled={(() => {
                                    const nextDate = new Date(startDate);
                                    nextDate.setDate(nextDate.getDate() + 7);
                                    const nextYear = getISOYear(nextDate);
                                    const nextWeek = getLocalWeek(nextDate);

                                    const today = new Date();
                                    const currentYear = getISOYear(today);
                                    const currentWeek = getLocalWeek(today);

                                    return (nextYear > currentYear) || (nextYear === currentYear && nextWeek > currentWeek);
                                })()}
                            >
                                &#8250;
                            </button>
                        </div>
                    </div>
                    <div className={styles.right}>
                        <FormActionButton
                            text={"Сохранить"}
                            disabled={isSaving}
                            className={stylesButtons.mainButton}
                            onClick={onSave}
                        />
                        <ExportToExcel
                            reportData={reportData}
                            isAdmin={isAdmin || false}
                            selectedWeek={selectedWeek.week}
                            selectedYear={selectedWeek.year}
                            userName={userName || 'Пользователь'}
                        />
                    </div>
                </div>
            )}
        </div>
    )
};